export default "__VITE_ASSET__BKN9ZQIF__"